import { Box, Typography, useTheme } from '@mui/material';
import React from 'react'
import ErrorIcon from '@mui/icons-material/Error';
import { Handle, Position } from '@xyflow/react';
import WebhookIcon from '@mui/icons-material/Webhook';
import { CustomTooltip } from '../../../../../components/TooltipCustomStyle';
import TooltipStatusTitle from '../../../../../components/TooltipStatusTitle';
import CheckHandleNodeEvent from '../../../../../utils/CheckHandleNodeEvent';

function ApplicationNode({ data, selected, id }) {

    const theme = useTheme();

    return (
        <>
            <div
                className='flex rounded-lg min-w-[160px] h-12 overflow-hidden'
            >
                <div className='bg-blue-600 p-2 rounded-tl-sm rounded-bl-lg justify-start items-center flex w-[45px] cursor-pointer'>
                    <WebhookIcon className='text-white' sx={{ fontSize: 28 }} />
                </div>
                <div className={`bg-white px-3 w-full h-full rounded-tr-lg rounded-br-lg ${selected ? 'border border-blue-600' : 'border border-gray-500'} flex flex-col justify-center items-left`}>
                    <div>
                        <Typography
                            variant='subtitle1'
                            fontSize={{
                                lg: 12,
                                md: 10,
                                sm: 10,
                                xs: 10
                            }}
                            sx={{
                                cursor: 'pointer',
                            }}
                        >
                            {data?.general_properties?.name?.client_name || 'Undifined'}
                        </Typography>
                    </div>
                    <div>
                        <Typography
                            variant="subtitle2"
                            fontSize={{
                                lg: 10,
                                md: 8,
                                sm: 8,
                                xs: 8
                            }}
                            sx={{
                                cursor: 'pointer',
                                color: 'GrayText'
                            }}
                        >
                            {data?.general_properties?.name?.app_type || 'Undifined'}
                        </Typography>
                    </div>
                </div>
                {data?.error_text.length > 0 &&
                    <div
                        style={{
                            position: 'absolute',
                            top: '-15px',
                            right: '5%',
                            transform: 'translate(-50%, 0)',
                            zIndex: 1000,
                            textAlign: 'center',
                        }}
                    >
                        <CustomTooltip title={<TooltipStatusTitle headerTitle="Error" listDetails={data?.error_text} />} arrow placement="top" tooltipcolorstyle={theme.palette.error.main}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '50%',
                                    background: '#fff',
                                    width: 15,
                                    height: 15,
                                    marginTop: '5px'
                                }}
                            >
                                <ErrorIcon sx={{
                                    color: theme.palette.error.main,
                                    fontSize: 18,
                                }} />
                            </Box>
                        </CustomTooltip>
                    </div>
                }
            </div>
            <Handle
                id="top-target"
                type="target"
                position={Position.Top}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                id="top-source"
                type="source"
                position={Position.Top}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                id="bottom-target"
                type="target"
                position={Position.Bottom}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                id="bottom-source"
                type="source"
                position={Position.Bottom}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                id="left-target"
                type="target"
                position={Position.Left}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                id="left-source"
                type="source"
                position={Position.Left}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                id="right-target"
                type="target"
                position={Position.Right}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                id="right-source"
                type="source"
                position={Position.Right}
                style={CheckHandleNodeEvent(data, selected)}
            />
        </>
    )
}

export default ApplicationNode